export enum EmailTemplateTipos {
  // SISTEMA ( sistemacnet@tusegurodeviaje.net )
  NuevoUsuario = 1,
  ResetearContrasenia = 10,
  Notificaciones = 11,
  Cumpleaños = 4,

  // CONFIGURABLE POR CLIENTE
  Comparativa = 2,
  Seguimiento = 8,
  PrimerContacto = 7,
  CotizacionPedidoDescuento = 6,

  // SISTEMA AUTOMATICO ( clientes@tusegurodeviaje.net )
  ConfirmacionPago = 3,
  PagoPendiente = 5,
  Voucher = 9,
  ReenvioVoucher = 12,
}
